import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import Spinner from '../../UI/Spinner/Spinner';
import { nombreAccion, detalleAccion } from '../UltimaAccionImpresion/UltimaAccionImpresion';
import colores from '../Bandeja/coloresBandeja';

const iconosAccion = {
  Descarga: GetAppIcon,
  Mail: MailOutlineIcon,
  Whatsapp: WhatsAppIcon
};

const useStyles = makeStyles(() => ({
  lista: {
    listStyle: 'none',
    margin: 0,
    padding: '0 0 0 26px',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '9px',
      top: '6px',
      bottom: '6px',
      width: '2px',
      backgroundColor: colores.linea
    }
  },
  item: {
    position: 'relative',
    paddingBottom: '16px',
    fontSize: '13px'
  },
  icono: {
    position: 'absolute',
    left: '-26px',
    top: 0,
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: colores.primario,
    color: 'white',
    display: 'grid',
    placeItems: 'center',
    '& svg': {
      fontSize: '13px'
    }
  },
  detalle: {
    fontSize: '12px',
    color: colores.tenue,
    // Las direcciones de mail largas se cortan en lugar de desbordar en pantallas chicas
    overflowWrap: 'anywhere'
  }
}));

/** Todas las descargas y envíos del comprobante, de la más nueva a la más vieja. */
const HistorialComprobante = ({ acciones, error }) => {
  const classes = useStyles();

  if (error) return <Typography color="error">{error}</Typography>;
  if (!acciones) return <Spinner size="small" />;
  if (acciones.length === 0) {
    return (
      <Typography variant="body2" style={{ color: colores.tenue }}>
        Todavía no se descargó ni se envió.
      </Typography>
    );
  }

  return (
    <ul className={classes.lista}>
      {acciones.map((accion, indice) => {
        const Icono = iconosAccion[accion.accion] || GetAppIcon;
        return (
          <li key={`${accion.fecha}-${indice}`} className={classes.item}>
            <span className={classes.icono}>
              <Icono />
            </span>
            <div style={{ fontWeight: 500 }}>{nombreAccion(accion)}</div>
            <div className={classes.detalle}>
              {detalleAccion(accion)}
              {accion.destinatarios ? ` · ${accion.destinatarios}` : ''}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default HistorialComprobante;
